var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accident",
    transform: "translate(-510 -234)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 52,
    height: 52,
    rx: 12,
    transform: "translate(510 234)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bus_accident",
    "data-name": "bus accident",
    transform: "translate(122 -104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 36,
    height: 36,
    transform: "translate(396 346)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338",
    transform: "translate(133.831 24.538)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 0.87,
    cy: 0.87,
    r: 0.87,
    transform: "translate(278.43 347.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 0.87,
    cy: 0.87,
    r: 0.87,
    transform: "translate(287.995 347.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16024",
    "data-name": "Group 16024",
    transform: "translate(-4.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_50-2",
    "data-name": "Rectangle 50",
    d: "M2.609,1.3a1.306,1.306,0,0,0-1.3,1.3V17.391a1.306,1.306,0,0,0,1.3,1.3H14.783a1.306,1.306,0,0,0,1.3-1.3V2.609a1.306,1.306,0,0,0-1.3-1.3H2.609m0-1.3H14.783a2.609,2.609,0,0,1,2.609,2.609V17.391A2.609,2.609,0,0,1,14.783,20H2.609A2.609,2.609,0,0,1,0,17.391V2.609A2.609,2.609,0,0,1,2.609,0Z",
    transform: "translate(275.386 332)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    d: "M1.3,1.3V10H16.087V1.3H1.3M0,0H17.391V11.3H0Z",
    transform: "translate(275.386 335.479)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_37",
    "data-name": "Line 37",
    d: "M.554,8.7H-.75V0h1.3Z",
    transform: "translate(284.136 336.78)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_38",
    "data-name": "Line 38",
    d: "M5.12.554H-.1A.652.652,0,0,1-.75-.1.652.652,0,0,1-.1-.75H5.12A.652.652,0,0,1,5.772-.1.652.652,0,0,1,5.12.554Z",
    transform: "translate(281.571 348.62)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16023",
    "data-name": "Group 16023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_40",
    "data-name": "Line 40",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(278.093 351.13)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_41",
    "data-name": "Line 41",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(286.789 351.13)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_42",
    "data-name": "Line 42",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(281.571 351.13)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_43",
    "data-name": "Line 43",
    d: "M.554,2.609H-.75V0h1.3Z",
    transform: "translate(290.267 351.13)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_23_-_Outline",
    "data-name": "Ellipse 23 - Outline",
    d: "M.87,0A.87.87,0,1,1,0,.87.87.87,0,0,1,.87,0Z",
    transform: "translate(278.43 347.652)",
    fill: "#19bc9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_24_-_Outline",
    "data-name": "Ellipse 24 - Outline",
    d: "M.87,0A.87.87,0,1,1,0,.87.87.87,0,0,1,.87,0Z",
    transform: "translate(287.995 347.652)",
    fill: "#19bc9c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_27743",
    "data-name": "Path 27743",
    d: "M-1337.746,2762.28a.444.444,0,0,1-.14-.023l-4.071-1.368a.44.44,0,0,1-.277-.557.439.439,0,0,1,.557-.277l2.66.894-1.75-2.2a.44.44,0,0,1-.083-.378.441.441,0,0,1,.247-.3l2.394-1.075-2.283-.365a.44.44,0,0,1-.37-.456l.186-3.819-1.717,2.292a.44.44,0,0,1-.352.176h0a.439.439,0,0,1-.352-.177l-1.609-2.158.262,2.5a.44.44,0,0,1-.191.41.44.44,0,0,1-.452.025l-.591-.31.7.792a.44.44,0,0,1-.04.621.439.439,0,0,1-.621-.04l-2.27-2.58a.44.44,0,0,1-.016-.562.441.441,0,0,1,.55-.117l1.971,1.036-.344-3.274a.44.44,0,0,1,.278-.456.44.44,0,0,1,.513.147l2.214,2.969,2.226-2.97a.44.44,0,0,1,.5-.15.439.439,0,0,1,.29.435l-.237,4.86,3.347.535a.44.44,0,0,1,.366.376.44.44,0,0,1-.256.459l-3.22,1.447,2.325,2.923a.44.44,0,0,1,.016.526A.44.44,0,0,1-1337.746,2762.28Z",
    transform: "translate(1631.947 -2425.043)",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_44",
    "data-name": "Line 44",
    d: "M28.6.554H-.1A.652.652,0,0,1-.75-.1.652.652,0,0,1-.1-.75H28.6A.652.652,0,0,1,29.25-.1.652.652,0,0,1,28.6.554Z",
    transform: "translate(265.919 353.837)",
    fill: "#006"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccident);
export default __webpack_public_path__ + "static/media/accident.7aba3d88bc77ae8216533f12fc529acc.svg";
export { ForwardRef as ReactComponent };